import React from 'react';
import intl from 'react-intl-universal';
import PropTypes from 'prop-types';
import {
  Modal,
  Button,
  Input,
} from 'antd';

export default class PromptPassword extends React.Component {
  static propTypes = {
    onOk: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    options: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      visible: true,
      password: '',
    };
    this.passwordRef = React.createRef();
  }

  componentDidMount() {
    this.passwordRef.current && this.passwordRef.current.focus();
  }

  cancelOnClick = () => {
    this.setState({ visible: false }, () => {
      this.props.onCancel();
    });
  };

  okOnClick = async () => {
    this.setState({ visible: false }, () => {
      this.props.onOk(this.state.password);
    });
  };

  render() {
    const { options } = this.props;

    return (
      <Modal
        className="prompt-password"
        width={400}
        visible={this.state.visible}
        title={intl.get('PromptPassword.Title')}
        onCancel={this.cancelOnClick}
        getContainer={false}
        footer={[
          <Button key="cancel" onClick={this.cancelOnClick}>{intl.get('Cancel')}</Button>,
          <Button key="ok" type="primary" onClick={this.okOnClick}>{intl.get('Ok')}</Button>,
        ]}
      >
        <div className="mb-15">{intl.formatMessage({id:'PromptPassword.Desc'}, { fileName: options.fileName })}</div>
        <div className="d-f ai-c">
          <div className="w-140 pr-10 fs-0 ta-r">{intl.get('PromptPassword.EnterPassword')}</div>
          <Input.Password
            size="small"
            ref={this.passwordRef}
            value={this.state.password}
            onChange={e => this.setState({ password: e.target.value })}
            onPressEnter={this.okOnClick}
          />
        </div>
      </Modal>
    );
  }
}